import React, { useState, useEffect, useRef } from 'react';
import { Plus } from 'lucide-react';


const FloatingActionButton = ({ isDarkMode }) => {
  return (
    <div
      className={`fixed bottom-8 right-8 w-15 h-15 rounded-full flex items-center justify-center text-2xl shadow-md cursor-pointer transition-all duration-200 hover:scale-105 z-10 ${
        isDarkMode 
          ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-black shadow-opacity-30' 
          : 'bg-gray-900 hover:bg-gray-800 text-white shadow-gray-900 shadow-opacity-10'
      }`}
      onClick={() => console.log('Create new bot')}
      role="button"
      aria-label="Create new bot"
      tabIndex={0}
    >
      <Plus className="w-6 h-6" />
    </div>
  );
};

export default FloatingActionButton;